<template>
  <v-card class="box-container ma-0 pa-2" align="center" justify="center" :width="getWidth">
    <v-card-actions class="row-header ma-0 pa-4">
      <v-col class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" align="center" justify="center">
          <span>{{ title }}</span>
        </v-row>
        <v-divider></v-divider>
        <v-row class="ma-0 pa-0" align="center" justify="center" v-if="!hideSearch">
          <v-text-field v-model="searchText" :label="multiple ? 'Търсене' : 'Търсене / филтриране'" hide-details></v-text-field>
        </v-row>
      </v-col>
    </v-card-actions>
    <v-card-actions class="row-content">
      <v-col class="ma-0 pa-0" style="max-height: 400px">
        <v-row v-if="searchText && getData.length == 0" style="height: 40px" align="center" justify="center" class="ma-0 pa-0">
          <span>Не са намерени данни по търсения критерий</span>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="multiple" style="max-height: 400px">
          <v-virtual-scroll ref="refVirtualScroll" :height="400 - (searchText && getData.length == 0 ? 40 : 0)" :item-height="getButtonsHeight()" :items="getData" :width="getWidth">
            <template v-slot="{ item, index }">
              <!-- <v-checkbox class="ma-0 pa-0 px-2" :ripple="false" hide-details multiple :persistent-hint="true" v-model="selected" :value="item" :label="item.toString()" :color="isInDarkMode ? '' : 'grey'"></v-checkbox> -->
              <v-switch inset class="ma-0 pa-0 px-2" multiple density="compact" v-model="selected" :value="item" hide-details :color="Colors.IconColor">
                <template v-slot:label>
                  <v-tooltip v-if="tooltipFn" :disabled="hideTooltips" right>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" :style="(isOnMobile ? 'font-size: 14px; ' : 'font-size: 14px;') + (lastFoundIdx != null && index == lastFoundIdx ? 'text-decoration: underline;' : '')">{{
                        (toStringFn ? toStringFn(item) : item.toString()).padEnd(50, " ").substring(0, 50)
                      }}</span>
                    </template>
                    {{ tooltipFn(item) }}
                  </v-tooltip>
                  <span v-else :style="(isOnMobile ? 'font-size: 14px; ' : 'font-size: 14px;') + (lastFoundIdx != null && index == lastFoundIdx ? 'text-decoration: underline;' : '')">{{
                    (toStringFn ? toStringFn(item) : item.toString()).padEnd(50, " ").substring(0, 50)
                  }}</span>
                </template>
              </v-switch>
            </template>
          </v-virtual-scroll>
        </v-row>
        <div v-else :style="'max-height: ' + (getButtonsHeight() * 10 + 4) + 'px'">
          <v-row v-for="(item, idx) in getData" :key="idx" class="ma-0 pa-0" align="center" justify="center">
            <v-btn class="ma-1 pa-1" variant="outlined" @click="itemClick(item)" :style="selected == item ? 'background: ' + Colors.ActiveItemBackground + '; font-weight: bold;' : ''" width="100%">
              <v-icon v-if="item.icon" class="pr-2" :color="Colors.IconColor">{{ item.icon }}</v-icon>
              {{ (toStringFn ? toStringFn(item) : item.toString()).padEnd(50, " ").substring(0, 50) }}</v-btn
            >
          </v-row>
        </div>
      </v-col>
    </v-card-actions>
    <v-card-actions class="row-header ma-0 pa-0">
      <v-col>
        <v-row v-if="multiple" class="ma-2 pa-0" align="center">
          <span>{{ "Избрани: " + selectedText() }}</span>
        </v-row>
        <v-row class="ma-2 pa-0" align="center" justify="center">
          <v-col cols="5" class="ma-0 pa-0" justify="start">
            <!-- <Button  v-if="buttonCancelText" :btnText="buttonCancelText" style="display: flex; cursor: pointer; width: 200px; height: 100%" @click="selectItem(false)"> </Button> -->
            <v-btn :elevation="5" v-if="buttonCancelText" :text="buttonCancelText" :width="isOnMobile ? '120' : '150'" style="display: flex; cursor: pointer" v-on:click="selectItem(false)"> </v-btn>
            <!-- <Button :class="'ma-0 pa-2'" :btnText="buttonCancelText" @click.native="selectItem(false)" ></Button> -->
            <!-- <v-card v-if="buttonCancelText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'error'" class="ma-0 pa-2 no-text-transform white--text" @click="selectItem(false)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
            </v-card> -->
          </v-col>
          <v-col cols="2" class="ma-0 pa-0"></v-col>
          <v-col cols="5" class="ma-0 pa-0">
            <v-btn :elevation="5" v-if="buttonOKText" :btnIcon="'mdi-check'" :width="isOnMobile ? '120' : '150'" :text="buttonOKText" style="display: flex; cursor: pointer" v-on:click="selectItem(true)"> </v-btn>
            <!-- <v-card v-if="buttonOKText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="Colors.IconColor" class="ma-0 pa-2 no-text-transform white--text" @click="selectItem(true)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonOKText }}</span>
            </v-card> -->
          </v-col>
        </v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      dataitems: [],
      title: "",
      allowEmpty: false,
      buttonOKText: "ОК",
      buttonCancelText: "Отказ",
      searchText: "",
      lastFoundIdx: null,
      selected: null,
      multiple: false,
      hideSearch: false,
      toStringFn: undefined,
      tooltipFn: undefined,
      width: null,
    };
  },
  computed: {
    getWidth() {
      return this.width ? this.width : this.isOnMobile ? 400 : 700;
    },
    getData() {
      // if (this.multiple) {
      //   return this.data;
      // } else {
      if (this.toStringFn) {
        return this.dataitems.filter((d) => this.toStringFn(d).toLowerCase().contains(this.searchText.toLowerCase()));
      } else {
        return this.dataitems.filter((d) => d.toString().toLowerCase().contains(this.searchText.toLowerCase()));
      }
      // }
    },
  },
  methods: {
    selectedText() {
      return this.selected ? this.selected.map((s) => s.toString()).join(", ") : "";
    },
    getButtonsHeight() {
      return this.isOnMobile ? 50 : 30;
    },
    itemClick(item) {
      this.selected = item;
      if (!this.buttonOKText && !this.buttonCancelText) {
        this.selectItem(true);
      }
    },
    selectItem(confirm) {
      if (confirm) {
        if ((this.selected instanceof Array && this.selected.length == 0 && !this.allowEmpty) || !this.selected) {
          this.dialog.showError("Не сте избрали нищо!", { location: "center" });
          return;
        }
      } else {
        this.selected = null;
      }
      this.dialog.result = this.selected;
      this.dialog.close();
    },
  },
  watch: {
    // searchText(newVal) {
    //   if (!newVal) {
    //     this.lastFoundIdx = null;
    //   } else if (this.multiple) {
    //     var found = this.data.find(f =>
    //       f
    //         .toString()
    //         .toLowerCase()
    //         .contains(newVal.toLowerCase()),
    //     );
    //     if (found) {
    //       this.lastFoundIdx = this.data.indexOf(found);
    //       // this.$refs.refVirtualScroll.$el.scrollTo(0, this.lastFoundIdx * this.getButtonsHeight());
    //     } else {
    //       this.lastFoundIdx = null;
    //     }
    //   }
    // },
  },
  created() {
    this.dataitems = this.dialog.data;
    if (this.dialog.options) {
      this.title = this.dialog.options.title || "Избор";
      if (this.dialog.options.multiple) {
        this.multiple = this.dialog.options.multiple;
      }
      if (this.dialog.options.selected) {
        this.selected = this.dialog.options.selected;
      } else {
        this.selected = [];
      }
      if (this.dialog.options.hideSearch) {
        this.hideSearch = true;
      }
      if (this.dialog.options.allowEmpty) {
        this.allowEmpty = true;
      }
      if (this.dialog.options.buttonOKText != undefined) {
        this.buttonOKText = this.dialog.options.buttonOKText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
      if (this.dialog.options.toStringFn != undefined) {
        this.toStringFn = this.dialog.options.toStringFn;
      }
      if (this.dialog.options.tooltipFn != undefined) {
        this.tooltipFn = this.dialog.options.tooltipFn;
      }
      if (this.dialog.options.width != undefined) {
        this.width = this.dialog.options.width;
      }
    }
  },
  mounted() {},
};
</script>
